const config = {
  api: process.env.REACT_APP_API_URL,
  environment: process.env.REACT_APP_ENVIRONMENT,
  paypalClientId: process.env.REACT_APP_CLIENT_ID,
  newsletterModalDelay: process.env.REACT_APP_NEWSLETTER_MODAL_DELAY,
};

export default config;
